import { useContext } from 'react';
import { PreviousPregnanciesChartsDataContext } from '../contexts/PreviousPregnanciesChartsDataContext';

export const usePreviousPregnanciesChartsDataContext = () => {
    return useContext(PreviousPregnanciesChartsDataContext);
};
